import LightUpCommunication from '~/pages/communication/lightUp/libs/components/LightUpCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const LightUpCommunicationPage = (props: TPageProps) => (
  <LightUpCommunication {...props} />
)

export default LightUpCommunicationPage
